import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-398f3798"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center w-full pb-3 border-b gap-x-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-900" }, "Subject:", -1))
const _hoisted_3 = { class: "flex flex-col w-full" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col flex-wrap self-start gap-y-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Attachments", -1))
const _hoisted_8 = { class: "flex flex-row-reverse items-center justify-between w-full" }
const _hoisted_9 = { class: "flex items-center gap-x-4" }
const _hoisted_10 = {
  key: 1,
  class: "flex"
}
const _hoisted_11 = { class: "flex justify-start items-center" }
const _hoisted_12 = { class: "flex items-center justify-center mr-4 h-12 w-12 rounded-full bg-primary-color-100" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-lg leading-6 font-medium text-gray-900" }, "Schedule Email", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex items-center justify-center" }
const _hoisted_16 = { class: "text-base font-medium text-primary-color-600" }
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base font-medium text-primary-color-600" }, "Pick Date & Time", -1))
const _hoisted_19 = {
  key: 0,
  class: "flex gap-x-4 mt-2"
}
const _hoisted_20 = { class: "flex justify-end" }

import { onMounted, ref, computed, provide, watch } from "vue"
import { useRoute } from "vue-router"

import GgmsButton from "@/components/GgmsButton.vue"
import GgmsModal from "@/components/GgmsModal.vue"
import GgmsSeparator from "@/components/GgmsSeparator.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsRichTextEditor from "@/components/GgmsRichTextEditor.vue"
import GgmsFileUpload from "@/components/GgmsFileUpload.vue"
import GgmsChip from "@/components/GgmsChip.vue"
import MessageTemplatesModal from "./message/MessageTemplatesModal.vue"
import GgmsBasicEmailParts from "@/components/GgmsBasicEmailParts.vue"
import { CalendarIcon, DocumentTextIcon, TrashIcon, ClockIcon, PaperClipIcon } from "@heroicons/vue/outline"
import { useLeadsStore } from "@/stores/leads"
import { useEmailStore } from "@/stores/email"
import { useConfigStore } from "@/stores/config"
import { useAgencyStore } from "@/stores/agency"
import { useAuthStore } from "@/stores/auth"
import { useInboxStore } from "@/stores/inbox"

import { ToastService } from "@/shared/services/toast"
import { GgmsError } from "@/shared/services/client"

import { Lead } from "@/shared/models/lead"
import { EmailPayload } from "@/shared/models/email"
import { Agent } from "@/shared/models/agent"
import { UploadFile, UploadItem } from "@/shared/models/upload-file"
import { Integration, PayloadIntegration } from "@/shared/models/integration"
import { Inbox, InboxContact } from "@/shared/models/inbox"
import { Sender } from "@/shared/models/sender"

import {
    hasErrorMessage,
    formatHumanReadableDate,
    getDateInputFormat,
    getTimeInputFormat,
    setTomoroowMorning,
    renderTemplate,
    setThisAfternoon,
    formatTaskDate,
    getFullName,
    stripHtml,
} from "@/shared/utils/helpers"
import { useWorkflowStore } from "@/stores/workflow"
import { useIntegrationStore } from "@/stores/integration"
import DNDWarningComponent from "@/components/profile-details/do-not-disturb/DNDWarningComponent.vue"

interface Props {
    replyToId?: string
    message?: Inbox
    integration?: PayloadIntegration
    isForward?: boolean
    isWorkflow?: boolean
    fromInbox?: boolean
    isReplyAll?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatingEmail',
  props: {
    replyToId: {},
    message: {},
    integration: {},
    isForward: { type: Boolean },
    isWorkflow: { type: Boolean, default: false },
    fromInbox: { type: Boolean, default: false },
    isReplyAll: { type: Boolean, default: false }
  },
  emits: ["onDelete", "update:replyToId", "sendFromInbox", "saveEmail"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const leadStore = useLeadsStore()
const emailStore = useEmailStore()
const agencyStore = useAgencyStore()
const configStore = useConfigStore()
const authStore = useAuthStore()
const inboxStore = useInboxStore()
const workflowStore = useWorkflowStore()
const integrationStore = useIntegrationStore()
const toastService = new ToastService()
const route = useRoute()

const emit = __emit

provide("contactOverlayTarget-to", "creatingEmail")
provide("contactOverlayTarget-cc", "emailCcField")
provide("contactOverlayTarget-bcc", "emailBccField")

const isTemplatesModalOpen = ref(false)
const subject = ref("")
const message = ref("")
const recipients = ref([] as InboxContact[])
const fromUser = ref(authStore.currentUser)
const emailSender = ref<Sender>({ name: fromUser.value?.fullName || "", email: fromUser.value?.email })
const integrations = computed(() => configStore.integrations as Integration[])

const myEmails = ref<string[]>([])
const showContactSelect = ref(false)
const isOpenScheduleEmailModal = ref(false)
const isOpenCustomSchedule = ref(false)
const isSaveButtonDisabled = computed(
    () =>
        isCreatingEmail.value ||
        (props.isWorkflow && (stripHtml(message.value).length === 0 || subject.value.length === 0))
)

const customScheduleDate = ref(getDateInputFormat(new Date()))
const customScheduleTime = ref(getTimeInputFormat(new Date()))

const scheduleDate = ref<Date>()
const scheduleOptions = ref([
    {
        text: "Tomorrow morning",
        date: setTomoroowMorning(),
    },
])
const fileList = ref<File[]>([])
const localErrorMessage = computed(() =>
    emailStore.validationError?.fullMessage?.includes("Subject") ? emailStore.validationError.message : ""
)
const invalidSubjectStyle = computed(() => (localErrorMessage.value ? "ring-1 ring-red-500 rounded-md" : ""))
const isCreatingEmail = ref(false)
const gmailIntegration = computed(() =>
    configStore.integrations.find((i) => i.integrationName === "gmail" && i.fromAddress === emailSender.value.email)
)
const sendGridIntegration = computed(() => configStore.integrations.find((i) => i.integrationName === "sendgrid"))
const outlookIntegration = computed(() =>
    configStore.integrations.find((i) => i.integrationName === "outlook" && i.isEnabled)
)

const cc = ref<InboxContact[]>([])
const bcc = ref<InboxContact[]>([])

const to = computed(() => props.message?.to?.map((to) => to.email?.emailAddress) || [])
const from = computed(() => props.message?.from?.email?.emailAddress || "")
const isReply = computed(() => !!props.message?.subject && !props.isWorkflow)
const replyToId = computed({
    get: () => props.replyToId,
    set: (value) => {
        emit("update:replyToId", value)
    },
})

const disabledClass = computed(() => (isCreatingEmail.value ? "opacity-50 pointer-events-none cursor-not-allowed" : ""))

function addRecipient(lead: Lead, index?: number) {
    const recipient = {
        _id: lead._id,
        fullName: getFullName(lead?.firstName, lead?.lastName),
        email: lead.emails?.[0]?.emailAddress,
        doNotDisturb: lead?.doNotDisturb,
    } as InboxContact

    if (!recipients.value.map((recipient) => recipient._id).includes(recipient._id) && recipient?.email) {
        index ? recipients.value.splice(index, 0, recipient) : recipients.value.push(recipient)
    }
    showContactSelect.value = false
}

async function createEmail() {
    try {
        isCreatingEmail.value = true
        if (props.isWorkflow) {
            emit("saveEmail")
        }

        const to = [] as string[]
        recipients.value.forEach((contact) => {
            if (contact?.email) {
                to.push(contact.email)
            }
        })

        const emailPayload: EmailPayload = {
            body: message.value,
            plain: message.value,
            subject: subject.value,
            from: {
                email: {
                    emailAddress: emailSender.value.email || "",
                },
            },
            to: to.map((email) => ({ email: { emailAddress: email } })),
            cc: cc.value?.map((contact) => contact.email),
            bcc: bcc.value?.map((contact) => contact.email),
            themeChannel: "RichEmail",
        }

        // remove cc and bcc if empty
        if (!emailPayload.cc?.length) {
            delete emailPayload.cc
        }
        if (!emailPayload.bcc?.length) {
            delete emailPayload.bcc
        }

        if (gmailIntegration.value && emailSender.value?.email === gmailIntegration.value?.fromAddress) {
            emailPayload.integration = {
                _id: gmailIntegration.value._id,
                integrationName: gmailIntegration.value.integrationName,
                integrationType: gmailIntegration.value.integrationType,
            }
        }
        if (sendGridIntegration.value && emailSender.value?.integrationName === "sendgrid") {
            emailPayload.integration = {
                _id: sendGridIntegration.value._id,
                integrationName: sendGridIntegration.value.integrationName,
                integrationType: sendGridIntegration.value.integrationType,
            }
        }
        if (outlookIntegration.value && emailSender.value?.email === outlookIntegration.value?.fromAddress) {
            emailPayload.integration = {
                _id: outlookIntegration.value._id,
                integrationName: outlookIntegration.value.integrationName,
                integrationType: outlookIntegration.value.integrationType,
            }
        }

        if (emailSender.value?.email === outlookIntegration.value?.fromAddress) {
            emailPayload.integration = {
                _id: outlookIntegration.value._id,
                integrationName: outlookIntegration.value.integrationName,
                integrationType: outlookIntegration.value.integrationType,
            }
        }

        if (replyToId.value && !props.isForward) {
            emailPayload.replyToId = replyToId.value
        }

        const possibleSenderEmails = configStore.integrations
            .filter(
                (integration) =>
                    integration.integrationName === "gmail" ||
                    integration.integrationName === "outlook" ||
                    integration.integrationName === "sendgrid"
            )
            .map((integration) => integration.fromAddress)

        if (replyToId.value) {
            emailPayload.subject = setSubject()
            emailPayload.integration = props.integration
            if (possibleSenderEmails.includes(props.message?.to?.[0]?.email?.emailAddress)) {
                emailPayload.to = [{ email: { emailAddress: props.message?.from?.email?.emailAddress || "" } }]
                emailPayload.from = props.message.to[0]
            } else {
                emailPayload.to = props.message.to
                emailPayload.from = props.message.from
            }

            emailPayload.to = recipients.value.reduce((unique, recipient) => {
                const newRecipient = { email: { emailAddress: recipient.email }, _id: recipient?._id }
                if (
                    !unique.some(
                        (obj) =>
                            obj.email.emailAddress === newRecipient.email.emailAddress && obj._id === newRecipient._id
                    ) &&
                    newRecipient.email.emailAddress !== emailPayload.from.email.emailAddress
                ) {
                    unique.push(newRecipient)
                }
                return unique
            }, emailPayload.to)
        }

        if (props.isForward) {
            emailPayload.subject = setSubject()
            emailPayload.integration = props.integration

            if (possibleSenderEmails.includes(props.message?.to?.[0]?.email?.emailAddress)) {
                emailPayload.from = props.message.to[0]
            } else {
                emailPayload.from = props.message.from
            }

            emailPayload.to = recipients.value.map((recipient) => ({
                email: { emailAddress: recipient.email },
                _id: recipient?._id,
            }))
        }

        if (!emailPayload?.to?.length && !props.isWorkflow) {
            toastService.addToast({
                message: "Unable to send email. There are no contacts to send the message to.",
                type: "error",
            })
            return
        }
        if (scheduleDate.value) {
            emailPayload.scheduledAt = scheduleDate.value
        }
        if (fileList.value.length) {
            const uploads: UploadItem[] = fileList.value.map((file) => ({ name: file.name, mimetype: file.type }))
            const files: UploadFile[] = await emailStore.requestPostDataForFileUpload(uploads, fileList.value)
            emailPayload.files = files
        }

        const leadId = leadStore?.lead?._id
        if (replyToId.value || props.isForward) {
            const res = (await emailStore.createEmail(emailPayload)) as { threads: Inbox[] }
            if (res?.threads?.[0]?.messages?.[0]) {
                inboxStore.selectedItem?.messages?.push(res.threads[0].messages[0])
            }
        } else if (leadId) {
            if (props.isWorkflow) {
                workflowStore.messagePayload = emailPayload
            } else {
                await emailStore.createEmail(emailPayload, leadId)
                await leadStore.getOne(leadId)
            }
        } else {
            if (props.isWorkflow) {
                workflowStore.messagePayload = emailPayload
            } else {
                await emailStore.createEmail(emailPayload)
            }
        }

        if (props.fromInbox) {
            emit("sendFromInbox")
        }

        if (!emailStore.validationError.message) {
            subject.value = ""
            message.value = ""
            scheduleDate.value = undefined
            fileList.value = []
            recipients.value = []
            addRecipient(leadStore.lead)
            replyToId.value = ""
            cc.value = []
            bcc.value = []
        }
    } finally {
        isCreatingEmail.value = false
    }
}

function setSubject() {
    if (props.isForward && !props.message?.subject?.startsWith("Fwd:") && !props.isWorkflow) {
        return `Fwd: ${props.message?.subject}`
    }
    if (!props.isForward && !props.message?.subject?.startsWith("Re:") && !props.isWorkflow) {
        return `Re: ${props.message?.subject}`
    }
    return props.message?.subject || ""
}

function openScheduleEmailModal() {
    isOpenScheduleEmailModal.value = true
    const afternoonSchedule = setThisAfternoon(scheduleOptions.value)
    if (afternoonSchedule) {
        scheduleOptions.value.push(afternoonSchedule)
    }
}

function closeScheduleEmailModal() {
    isOpenScheduleEmailModal.value = false
    isOpenCustomSchedule.value = false
    customScheduleDate.value = getDateInputFormat(new Date())
    customScheduleTime.value = getTimeInputFormat(new Date())
}

function toggleCustomSchedule() {
    isOpenCustomSchedule.value = !isOpenCustomSchedule.value
}

function setScheduleTime() {
    const date = new Date(customScheduleDate.value)
    const hours = Number(customScheduleTime.value.split(":")[0])
    const minutes = Number(customScheduleTime.value.split(":")[1])
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes)
}

function saveScheduleEmail(date?: Date) {
    scheduleDate.value = date || setScheduleTime()

    createEmail()
    closeScheduleEmailModal()
}

function onItemDeleted(fileName: string) {
    fileList.value = fileList.value.filter((file) => file.name !== fileName)
}

function onDelete() {
    emit("onDelete")
}

function toggleTemplateModal(isOpen: boolean) {
    isTemplatesModalOpen.value = isOpen
}

function clearValidationError() {
    emailStore.validationError = {} as GgmsError
}

function updateTemplate(template: { subject: string; body: string }) {
    const models = {
        lead: leadStore.lead,
        agency: agencyStore.agency,
        agent: {} as Agent,
    }
    subject.value = template.subject
    message.value = template.body
    // recipients.value.length > 1 ? template.body : renderTemplate(template.body, configStore.prototypes, models)
}

function createMessageQuote() {
    if (!props.message) return

    if (props.isWorkflow) {
        message.value = props.message.body
        subject.value = props.message.subject
        emailSender.value = { name: "", email: props.message.from?.email?.emailAddress }
        return
    }

    const messageBody = props.message?.body || props.message?.plain || props.message?.snippet

    message.value = `<br/><br/><p style="font-size: 0.875rem"> On ${formatTaskDate(new Date(props.message.sentAt))} ${
        props.message.from?.email?.emailAddress.replaceAll('"', "") || ""
    } < ${
        props.message.from?.email?.emailAddress || ""
    } > wrote: </p><blockquote style="margin:0 0 0 .8ex;border-left:1px #ccc solid;padding-left:1ex"> ${messageBody} </blockquote>`

    const fromEmail = props.message?.from?.email?.emailAddress || ""
    recipients.value = [{ email: fromEmail }] as InboxContact[]
    if (props.isReplyAll) {
        convertIntegrationsToSenders()
        if (myEmails.value.some((email) => props.message?.cc?.includes(email))) {
            cc.value = props.message.to?.map((recipient) => {
                return {
                    email: recipient.email?.emailAddress,
                }
            })
        } else if (
            myEmails.value.some((email) =>
                props.message?.to?.map((recipients) => recipients.email?.emailAddress).includes(email)
            )
        ) {
            cc.value = props.message.cc?.map((email) => {
                return { email }
            })
        } else {
            cc.value = props.message.to
                ?.map((recipient) => {
                    return {
                        email: recipient.email?.emailAddress,
                    }
                })
                .concat(
                    props.message.cc?.map((email) => {
                        return { email }
                    }) as { email: string }[]
                )
        }
    }
}

function getSendgridSenderProp(propName: string) {
    return integrationStore.integrationConfig?.versions
        ?.at(-1)
        ?.sectionAnswers?.[1]?.answers?.find((answer) => answer.name === propName)?.textAnswers?.[0]
}

async function convertIntegrationsToSenders() {
    integrations.value
        .filter((integration) => integration.integrationType === "inboxEmail" && integration.isEnabled)
        .forEach((integration) => {
            myEmails.value.push(integration.fromAddress as string)
        })

    const sendgridIntegration = integrations.value.find((integration) => integration.integrationName === "sendgrid")
    if (!sendgridIntegration) {
        return
    }
    await integrationStore.getIntegration(sendgridIntegration._id)

    const sendgridSenderEmail = getSendgridSenderProp("item_5")
    const sendgridSenderName = getSendgridSenderProp("item_6")

    if (!sendgridSenderName || !sendgridSenderEmail) {
        return
    }
    myEmails.value.push(sendgridSenderEmail)
}

onMounted(() => {
    if (!props.isWorkflow && route.name !== "inbox") {
        addRecipient(leadStore.lead)
    }
    createMessageQuote()
    if (props.isForward) {
        recipients.value = []
    }
})

watch(
    () => leadStore.lead.emails,
    () => {
        const leadRecipientIndex = recipients.value.findIndex((recipient) => recipient._id === leadStore.lead._id)
        if (leadRecipientIndex < 0) {
            return
        }
        addRecipient(leadStore.lead, leadRecipientIndex)
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['flex flex-col justify-center items-center px-4 py-6 gap-y-6 relative', disabledClass.value])
    }, [
      _createVNode(GgmsBasicEmailParts, {
        recipients: recipients.value,
        "onUpdate:recipients": _cache[0] || (_cache[0] = ($event: any) => ((recipients).value = $event)),
        "selected-sender": emailSender.value,
        "onUpdate:selectedSender": _cache[1] || (_cache[1] = ($event: any) => ((emailSender).value = $event)),
        cc: cc.value,
        "onUpdate:cc": _cache[2] || (_cache[2] = ($event: any) => ((cc).value = $event)),
        bcc: bcc.value,
        "onUpdate:bcc": _cache[3] || (_cache[3] = ($event: any) => ((bcc).value = $event)),
        type: "email",
        isReply: isReply.value,
        isForward: _ctx.isForward,
        isWorkflow: _ctx.isWorkflow,
        to: to.value,
        from: from.value
      }, null, 8, ["recipients", "selected-sender", "cc", "bcc", "isReply", "isForward", "isWorkflow", "to", "from"]),
      _createVNode(DNDWarningComponent, {
        recipients: recipients.value,
        showLeadName: true
      }, null, 8, ["recipients"]),
      (!isReply.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((subject).value = $event)),
                class: _normalizeClass(["w-full h-8 px-2 py-1 text-gray-900 rounded-md focus:outline-none border-0 focus:ring-2 focus:ring-primary-color-500", invalidSubjectStyle.value]),
                onFocus: clearValidationError
              }, null, 34), [
                [_vModelText, subject.value]
              ]),
              (localErrorMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(localErrorMessage.value), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(GgmsRichTextEditor, {
          modelValue: message.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((message).value = $event)),
          "error-message": _unref(hasErrorMessage)('body', _unref(emailStore).validationError),
          placeholder: "Write your email",
          onDisableValidationError: clearValidationError
        }, null, 8, ["modelValue", "error-message"])
      ]),
      (fileList.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file) => {
                return (_openBlock(), _createBlock(GgmsChip, {
                  class: "mb-1 mr-2 w-fit",
                  key: file.name,
                  onOnRemove: ($event: any) => (onItemDeleted(file.name))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(file.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onOnRemove"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(DocumentTextIcon), {
            class: "w-6 h-6 cursor-pointer text-gray-400 hover:text-gray-600",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleTemplateModal(true)))
          }),
          _createVNode(GgmsFileUpload, {
            modelValue: fileList.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((fileList).value = $event)),
            "multiple-files": true,
            accept: ['image', 'video', 'audio', 'doc', 'pdf', 'excel', 'text'],
            "max-size": 5,
            "is-button-upload": true,
            class: "flex items-center justify-center w-fit"
          }, {
            alternative: _withCtx(({ upload }) => [
              _createVNode(_unref(PaperClipIcon), {
                class: "w-6 h-6 cursor-pointer text-gray-400 hover:text-gray-600",
                onClick: _withModifiers(($event: any) => (upload()), ["stop"])
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.isWorkflow)
            ? (_openBlock(), _createBlock(GgmsButton, {
                key: 0,
                classes: ['rounded-md'],
                disabled: isSaveButtonDisabled.value,
                onClick: createEmail
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(GgmsButton, {
                  classes: ['rounded-md rounded-r-none'],
                  onClick: createEmail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Send Email")
                  ]),
                  _: 1
                }),
                _createVNode(GgmsButton, {
                  classes: ['px-2 rounded-md rounded-l-none'],
                  onClick: openScheduleEmailModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CalendarIcon), { class: "w-6 h-6 text-white" })
                  ]),
                  _: 1
                })
              ]))
        ]),
        _createVNode(_unref(TrashIcon), {
          class: "w-6 h-6 cursor-pointer text-gray-400 hover:text-gray-600",
          onClick: onDelete
        })
      ]),
      _createVNode(MessageTemplatesModal, {
        open: isTemplatesModalOpen.value,
        "template-title": "Email",
        onCloseModal: _cache[8] || (_cache[8] = ($event: any) => (toggleTemplateModal(false))),
        "onUpdate:modelValue": updateTemplate,
        size: "3xl"
      }, null, 8, ["open"])
    ], 2),
    _createVNode(GgmsModal, {
      open: isOpenScheduleEmailModal.value,
      onCloseModal: closeScheduleEmailModal
    }, _createSlots({
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(CalendarIcon), { class: "h-6 w-6 text-primary-color-600" })
          ]),
          _hoisted_13
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleOptions.value, (schedule) => {
          return (_openBlock(), _createElementBlock("div", {
            key: schedule.text
          }, [
            _createElementVNode("div", {
              class: "flex justify-between items-center cursor-pointer",
              onClick: ($event: any) => (saveScheduleEmail(schedule.date))
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(ClockIcon), { class: "h-5 w-5 text-primary-color-600 mr-3" }),
                _createElementVNode("p", _hoisted_16, _toDisplayString(schedule.text), 1)
              ]),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(formatHumanReadableDate)(schedule.date, true)), 1)
            ], 8, _hoisted_14),
            _createVNode(GgmsSeparator, { class: "my-4" })
          ]))
        }), 128)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "flex items-center w-fit border-none bg-transparent",
            onClick: toggleCustomSchedule
          }, [
            _createVNode(_unref(CalendarIcon), { class: "h-5 w-5 text-primary-color-600 mr-3" }),
            _hoisted_18
          ]),
          (isOpenCustomSchedule.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(GgmsInput, {
                  modelValue: customScheduleDate.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((customScheduleDate).value = $event)),
                  class: "w-full",
                  type: "date",
                  iconStart: _unref(CalendarIcon)
                }, null, 8, ["modelValue", "iconStart"]),
                _createVNode(GgmsInput, {
                  modelValue: customScheduleTime.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((customScheduleTime).value = $event)),
                  class: "w-full",
                  type: "time",
                  iconStart: _unref(ClockIcon)
                }, null, 8, ["modelValue", "iconStart"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (isOpenCustomSchedule.value)
        ? {
            name: "under",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(GgmsButton, {
                  styleType: "secondary",
                  class: "mr-3",
                  onClick: closeScheduleEmailModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }),
                _createVNode(GgmsButton, {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (saveScheduleEmail()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Done")
                  ]),
                  _: 1
                })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["open"])
  ], 64))
}
}

})